import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import Project from '@/projects/entities/project'
import Node from '@/diagrams/models/node'
import EditNodeEvent from '@/diagrams/events/edit-node-event'
import CreateNodeEvent from '@/diagrams/events/create-node-event'
import projectsService from '@/projects/services/projects-service'
import { ProjectStatus } from '@/projects/entities/project-status'

@Component
export default class SideMenu extends Vue {

  @Prop()
  private value!: boolean

  private show = true
  private pValue: boolean = false

  private mode = 'menu'
  private parentId: null | string = null
  private node: Node = new Node()
  private project: Project | null = new Project()
  private state: DbState = 'idle'
  private editMode: boolean = false
  private togglePermanent: boolean = true
  private feedbackDialog: boolean = false

  @Watch('value')
  private valueChanged(newVal: boolean, oldVal: boolean) {
    if (newVal !== oldVal) {
      this.pValue = newVal
    }
  }

  @Watch('pValue')
  private pValueChanged(newVal: boolean, oldVal: boolean) {
    if (newVal !== oldVal) {
      this.$emit('input', newVal)
    }
  }

  @Watch('$route')
  private async routeChangedAsync() {
    await this.loadProjectAsync()
  }

  private async loadProjectAsync() {
    if (this.$route.params.projectId) {
      this.project = await projectsService.findAsync(this.$route.params.projectId)
    }
  }

  private toggleSideMenu() {
    this.pValue = !this.pValue
    this.$bus.$emit("sidemenu:toggle")
  }

  private setState(state: DbState) {
    this.state = state
    if (state === 'persisted') {
      setTimeout(() => { this.state = 'idle' }, 1000)
    }
  }

  private showFeedbackDialog() {
    this.feedbackDialog = true
  }

  private createNode(evt: CreateNodeEvent) {
    this.mode = 'edit-node'
    this.editMode = true
    this.parentId = evt.parent.dbId
    this.node = new Node('node', evt.className)
  }

  private editNode(evt: EditNodeEvent) {
    this.mode = 'edit-node'
    this.editMode = true
    this.parentId = null
    this.node = evt.node
  }

  private setMode(mode: string) {
    this.mode = mode
    this.node = new Node()
  }

  private async created() {
    this.$bus.$on('db:state', this.setState)
    this.$bus.$on('node:create', this.createNode)
    this.$bus.$on('node:edit', this.editNode)
    this.$bus.$on('node:unselect', () => { this.setMode('none') })
    this.$bus.$on('sidemenu:mode', this.setMode)
    this.$bus.$on('sidemenu:toggle', this.togglePermanentSidemenu)
  }

  private togglePermanentSidemenu() {
    this.togglePermanent = !this.togglePermanent
  }

  private async mounted() {
    this.pValue = this.value
    this.loadProjectAsync()
  }

  get archived() {
    return this.project != null && (this.project.status === ProjectStatus.Archived)
  }

  // TODO: Wird in zukunft nicht mehr benötigt da es Unterstützung für Templates gibt.
  private async updated() {
    this.show = this.$route.name != 'login' && this.$route.name !== 'reset-password'
  }

}
